/**
 * KAN-204 — the LAST KNOWN company access level, per user AND tenant, kept in
 * localStorage so a cold start for a SUSPENDED company shows the suspended
 * screen at the first render instead of flashing the app until the read lands.
 * Holds only the level string and the reason code — nothing else. Every read /
 * write is try/catch (storage can throw). Cleared at sign-out
 * (`clearPerUserDeviceState`). Client UX only; the server is the boundary.
 */
export const LAST_KNOWN_ACCESS_PREFIX = 'cvx-company-access-level-v1:';
const LEVELS = ['full', 'grace', 'read_only', 'suspended'];

const keyFor = (userId, tenantId) => `${LAST_KNOWN_ACCESS_PREFIX}${tenantId}:${userId}`;

export function writeLastKnownAccess(userId, tenantId, access) {
  if (!userId || !tenantId || !access || !LEVELS.includes(access.level)) return;
  try {
    window.localStorage.setItem(keyFor(userId, tenantId), JSON.stringify({ level: access.level, reason: access.reason || null }));
  } catch { /* best-effort cache */ }
}

/** @returns {{ level: string, reason: string|null }|null} null for no user / tenant, nothing stored, or unreadable. */
export function readLastKnownAccess(userId, tenantId) {
  if (!userId || !tenantId) return null;
  try {
    const parsed = JSON.parse(window.localStorage.getItem(keyFor(userId, tenantId)) || 'null');
    if (!parsed || !LEVELS.includes(parsed.level)) return null;
    return { level: parsed.level, reason: typeof parsed.reason === 'string' ? parsed.reason : null };
  } catch {
    return null;
  }
}
